export const isPublicInfoLoading = state => (window.location.pathname.includes("public-candidate")
  ? state.publicPage.isPublicInfoLoading || false : false);

export const getPublicUserInfo = state =>
  state?.publicPage?.publicCandidate || {};

export const getSharableLink = state => state.publicPage.sharableLink || "";
